import {
  openNotificationWithIcon,
  RemoteSession,
} from '@mss/mss-component-library';
import { Modal, notification } from 'antd';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import React from 'react';
import { TFunction } from 'i18next';
import Api from '../services/Api';
import classNames from 'classnames';

const Pre = ({ className, ...props }: React.ComponentProps<'pre'>) => {
  return (
    <pre
      className={classNames(
        'm-0 overflow-y-visible whitespace-normal last-of-type:mb-3.5',
        className
      )}
      {...props}
    />
  );
};

const revokeSession = async (
  t: TFunction,
  session: RemoteSession,
  fetchSession: () => void
) =>
  Modal.confirm({
    title: t('Are you sure you want to revoke this session?'),
    width: 530,
    icon: (
      <span className="anticon">
        <FontAwesomeIcon
          icon={faExclamationTriangle}
          color="#fd9644"
          size="sm"
        />
      </span>
    ),
    content: (
      <div>
        <p>{t("You're about to stop the following session")}:</p>
        <Pre>{`${t('Session ID')}: ${session.id}`}</Pre>
        <Pre>{`${t('Asset')}:      ${session.asset_object.name}`}</Pre>
        <Pre>{`${t('User')}:       ${session.user_object.name}`}</Pre>
        <p>
          {t('Note')}: {t('Linked remote request will be revoked!')}
        </p>
        <p>{t('Are you sure you want to continue?')}</p>
      </div>
    ),
    onOk: async () => {
      let result = await Api.session.revoke(session.id, 'Revoked');
      if (result.status === 200) {
        openNotificationWithIcon(
          notification.success,
          t('Session successfully stopped'),
          ''
        );
        fetchSession();
      } else {
        openNotificationWithIcon(
          notification.error,
          t('Session could not be killed'),
          t(
            'Due to technical issues the remote session could not be stopped. Please try again later.'
          )
        );
        console.error(t('Error!'), 'No API endpoint available');
      }
    },
    okButtonProps: { danger: true },
  });

export default revokeSession;
